var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('font-awesome-icon',{staticClass:"mr-1 cursor-pointer",attrs:{"icon":"font","size":"xs","transform":"down-3"},on:{"click":function($event){return _vm.changeFontSize(-1)}}}),_c('font-awesome-icon',{staticClass:"mr-1 cursor-pointer",attrs:{"icon":"font","size":"lg"},on:{"click":function($event){return _vm.changeFontSize(1)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }